/**
 * Internal depedencies
 */
import { editLayout } from 'state/dashboard-layouts/actions';
import { getDashboardLayout } from 'state/dashboard/selectors';
import { mergeById } from 'state/dashboard/utils';

export default (items) => (dispatch, getState) => {
	const layout = getDashboardLayout(getState());
	return layout && dispatch(editLayout(layout.id, { items: mergeById(layout.items, items) }));
};
